import type { LaneInfo } from '../api/client';

interface PositionsTableProps {
  lane: LaneInfo;
  prices: Record<string, number>;
}

export function PositionsTable({ lane, prices }: PositionsTableProps) {
  const symbols = Object.keys(lane.perSymbol ?? {});
  const openPositions = symbols
    .map((sym) => {
      const symData = lane.perSymbol?.[sym];
      if (!symData?.position) return null;
      return { sym, pos: symData.position };
    })
    .filter((entry): entry is { sym: string; pos: NonNullable<NonNullable<LaneInfo['perSymbol']>[string]['position']> } =>
      entry !== null
    );

  if (openPositions.length === 0) {
    return (
      <div className="card" style={{ height: '100%' }}>
        <div className="card-header">
          <span className="card-title">持仓</span>
        </div>
        <p className="muted" style={{ margin: 0 }}>无持仓</p>
      </div>
    );
  }

  return (
    <div className="card" style={{ height: '100%' }}>
      <div className="card-header">
        <span className="card-title">持仓</span>
      </div>
      <div className="trades-table">
        <table className="trade-table">
          <thead>
            <tr>
              <th>品种</th>
              <th>方向</th>
              <th>仓量</th>
              <th style={{ textAlign: 'right' }}>浮动盈亏</th>
            </tr>
          </thead>
          <tbody>
            {openPositions.map(({ sym, pos }) => {
              const price = prices[sym];
              let unrealized: number | null = null;
              if (price !== undefined) {
                const dir = pos.direction === 'LONG' ? 1 : -1;
                unrealized = (price - pos.entryPrice) * pos.size * dir;
              }
              const uColor = unrealized === null ? undefined
                : unrealized >= 0 ? '#4ade80' : '#f87171';

              return (
                <tr key={sym}>
                  <td style={{ fontWeight: 600 }}>{sym}</td>
                  <td>
                    <span style={{
                      padding: '2px 6px',
                      borderRadius: 4,
                      fontSize: '0.75rem',
                      fontWeight: 600,
                      background: pos.direction === 'LONG' ? 'rgba(74,222,128,0.15)' : 'rgba(248,113,113,0.15)',
                      color: pos.direction === 'LONG' ? '#4ade80' : '#f87171',
                    }}>
                      {pos.direction}
                    </span>
                  </td>
                  <td>{pos.size}</td>
                  <td className="text-right" style={{ color: uColor, fontWeight: 600 }}>
                    {unrealized === null
                      ? <span className="muted">—</span>
                      : `${unrealized >= 0 ? '+' : ''}${unrealized.toFixed(2)}`
                    }
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
